(function () {
  const MIN_CHARS = 50;
  const BODY_INPUT_SEL = '#jdgm-review-body-input';
  const NEXT_BTN_SEL = '.jdgm-write-review-modal__nav-btn.jdgm-write-review-modal__nav-btn-next';
  const ERROR_ID = 'jdgm-body-min-char-error';

  function getOrCreateError(input) {
    let error = document.getElementById(ERROR_ID);
    if (!error) {
      error = document.createElement('p');
      error.id = ERROR_ID;
      error.style.cssText = 'color:#c0392b;font-size:0.8em;margin-top:4px;display:none;';
      error.textContent = `Please write at least ${MIN_CHARS} characters.`;
      input.parentNode.insertBefore(error, input.nextSibling);
    }
    return error;
  }

  function validate(input) {
    const nextBtn = document.querySelector(NEXT_BTN_SEL);
    const error = getOrCreateError(input);
    const len = input.value.trim().length;

    if (len < MIN_CHARS) {
      if (nextBtn) {
        nextBtn.disabled = true;
        nextBtn.style.opacity = '0.5';
        nextBtn.style.cursor = 'not-allowed';
        nextBtn.style.pointerEvents = 'none';
      }
      if (len > 0) {
        error.textContent = `Please write at least ${MIN_CHARS} characters (${len}/${MIN_CHARS}).`;
        error.style.display = 'block';
      } else {
        error.style.display = 'none';
      }
    } else {
      if (nextBtn) {
        nextBtn.disabled = false;
        nextBtn.style.opacity = '';
        nextBtn.style.cursor = '';
        nextBtn.style.pointerEvents = '';
      }
      error.style.display = 'none';
    }
  }

  function attachValidation(input) {
    // Disable next button initially if input is empty/short
    validate(input);
    input.addEventListener('input', function () {
      validate(this);
    });
  }

  function observeModal() {
    const observer = new MutationObserver(function () {
      const input = document.querySelector(BODY_INPUT_SEL);
      if (input && !input.dataset.jdgmValidated) {
        input.dataset.jdgmValidated = 'true';
        attachValidation(input);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeModal);
  } else {
    observeModal();
  }
})();
